import axios from 'axios';

export const accountPayableApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/stk-account-payable/`,
    headers: {
        'Content-Type': 'application/json'
    }
})